module.exports = __webpack_public_path__ + "img/87469-smart2pay-banner.742a73dc.png";